<mat-accordion class="event-form-container" multi="true">
  <!--  MAIN BLOCK -->
  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.basic_information' | translate }}
        <mat-icon [style.color]="!isBasicValid() ? 'red' : ''">info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      <mat-checkbox [formField]="eventForm.online" class="full-width">
           {{ 'event.publish_event' | translate }}
      </mat-checkbox>
      <mat-form-field class="full-width">
        <mat-label>{{ 'event.event_title' | translate }}</mat-label>
        <input matInput [formField]="eventForm.title" placeholder="{{'event.event_title_description' | translate}}">
        @if (eventForm.title().invalid() && eventForm.title().touched()) {
          <mat-error>
            @for (error of eventForm.title().errors(); track error) {
              {{ error.message | translate }}
            }
          </mat-error>
        }
      </mat-form-field>
      @if (showCountrySelect()) {
        <mat-form-field class="third-width">
          <mat-label>{{ 'event.country' | translate }}</mat-label>
          <mat-select [formField]="eventForm.countryId">
            @for (country of countries(); track country.id) {
              <mat-option [value]="country.id">
                {{ country.name }}
              </mat-option>
            }
          </mat-select>
          @if (eventForm.countryId().invalid() && eventForm.countryId().touched()) {
            <mat-error>
              @for (error of eventForm.countryId().errors(); track error) {
                {{ error.message | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
      }
      @if (showCantonSelect()) {
        <mat-form-field class="third-width">
          <mat-label>{{ 'event.canton' | translate }}</mat-label>
          <mat-select [formField]="eventForm.cityId">
            @for (city of cities(); track city.id) {
              <mat-option [value]="city.id">
                {{ city.name }}
              </mat-option>
            }
          </mat-select>
          @if (eventForm.cityId().invalid() && eventForm.cityId().touched()) {
            <mat-error>
              @for (error of eventForm.cityId().errors(); track error) {
                {{ error.message | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
      }
      @if (showOrganizationSelect()) {
        <mat-form-field class="third-width">
          <mat-label>{{ 'event.organization' | translate }}</mat-label>
          <mat-select [formField]="eventForm.organizationId">
            @for (org of organizations(); track org.id) {
              <mat-option [value]="org.id">
                {{ org.name }}
              </mat-option>
            }
          </mat-select>
          @if (eventForm.organizationId().invalid() && eventForm.organizationId().touched()) {
            <mat-error>
              @for (error of eventForm.organizationId().errors(); track error) {
                {{ error.message | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
      }

      <mat-form-field class="half-width">
        <mat-label>{{ 'event.event_type' | translate }}</mat-label>
        <mat-select [formField]="eventForm.eventTypeId" placeholder="{{'event.event_type_description' | translate}}">
          @for (et of eventTypes(); track et.id) {
            <mat-option [value]="et.id">
              <div class="color" [style.border-color]="et.color">
                {{ et.name }}
              </div>
            </mat-option>
          }
        </mat-select>
        @if (eventForm.eventTypeId().invalid() && eventForm.eventTypeId().touched()) {
          <mat-error>
            @for (error of eventForm.eventTypeId().errors(); track error) {
              {{ error.message | translate }}
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label>{{ 'event.responsible' | translate }}</mat-label>
        <mat-select [formField]="eventForm.userId" placeholder="{{'event.responsible_description' | translate}}">
          @for (user of users(); track user.id) {
            <mat-option [value]="user.id">
              {{ user.firstName + ' ' + user.lastName }}
            </mat-option>
          }
        </mat-select>
        @if (eventForm.userId().invalid() && eventForm.userId().touched()) {
          <mat-error>
            @for (error of eventForm.userId().errors(); track error) {
              {{ error.message | translate }}
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>{{ 'event.target_group' | translate }}</mat-label>
        <mat-select [formField]="eventForm.targetGroup" multiple
                    placeholder="{{'event.target_group_description' | translate}}">
          <div class="global-select-header" (click)="$event.stopPropagation()">
            <mat-checkbox
              [checked]="isAllSelected()"
              [indeterminate]="isAllPartiallySelected()"
              (change)="toggleSelectAll($event)">
              <b>{{ 'frontUser.selectAll' | translate }}</b>
            </mat-checkbox>
          </div>
          <mat-divider></mat-divider>
          @for (group of targetGroups(); track group.name) {
            <mat-optgroup>
              <div class="group-header-container" (click)="$event.stopPropagation()">
                <mat-checkbox
                  [checked]="isGroupSelected(group)"
                  [indeterminate]="isGroupPartiallySelected(group)"
                  (change)="toggleGroupSelection($event, group)"
                  (click)="$event.stopPropagation()">
                  <b>{{ group.name }}</b>
                </mat-checkbox>
              </div>
              @for (item of group.data; track item.id) {
                <mat-option [value]="item.id" class="target-option">
                  {{ item.ageMask }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
        @if (eventForm.targetGroup().invalid() && eventForm.targetGroup().touched()) {
          <mat-error>
            @for (error of eventForm.targetGroup().errors(); track error) {
              {{ error.message | translate }}
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label>{{ 'event.visibility' | translate }}</mat-label>
        <mat-select [formField]="eventForm.eventVisibility" placeholder="{{'event.visibility_description' | translate}}">
          <mat-option [value]="'public'">
            {{ 'event.public' | translate }}
          </mat-option>
          <mat-option [value]="'internal'">
            {{ 'event.internal' | translate }}
          </mat-option>
          <mat-option [value]="'admins'">
            {{ 'event.admins_only' | translate }}
          </mat-option>
        </mat-select>
        @if (eventForm.eventVisibility().invalid() && eventForm.eventVisibility().touched()) {
          <mat-error>
            @for (error of eventForm.eventVisibility().errors(); track error) {
              {{ error.message | translate }}
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label>{{ 'main.tag' | translate }}</mat-label>
        <mat-select [formField]="eventForm.tags" multiple>
          @for (tag of tags(); track tag.id) {
            <mat-option [value]="tag.id">
              {{ tag.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (platforms().length > 1) {
        <mat-form-field class="half-width">
          <mat-label>{{ 'event.platforms' | translate }}</mat-label>
          <mat-select [formField]="eventForm.platforms" multiple>
            @for (plat of platforms(); track plat.id) {
              <mat-option [value]="plat.id">
                {{ plat.title }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <div class="quill-description">
        <div class="quill-title">{{ 'event.description' | translate }}</div>
        <quill-editor [ngModel]="eventModel().description" [modules]="{ toolbar: quillConfig }"
                      (onContentChanged)="onDescriptionChange($event)"></quill-editor>
      </div>
    </div>
  </mat-expansion-panel>
  <!--  IMAGE BLOCK -->
  <mat-expansion-panel expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.image' | translate }}
        <mat-icon [style.color]="(isPictureValid() || eventModel().picture) && !opennedCropper()  ? '' : 'red'">info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      <cropper-component [avatar]="eventModel().picture" [page]="'event'"
                         [defaultRatio]="true" (sendImg)="getMainImage($event)"
                         (cropperOpened)="openCropper($event)"></cropper-component>
    </div>
  </mat-expansion-panel>
  <!--  DATE AND LOCATION BLOCK -->
  <mat-expansion-panel expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.time_location' | translate }}
        <mat-icon [style.color]="!isTimeLocationValid() ? 'red' : ''">info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.event_date_type' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if (disableAll()) {
            <div class="has-participant-error">
              {{ 'has_participant_error' | translate }}
            </div>
          }
          <mat-checkbox [formField]="eventForm.ongoingEvent" class="full-width">
            <span [matTooltip]="'event.ongoing_event_description' | translate"
                  [matTooltipClass]="'ongoing-event-tooltip'">{{ 'event.ongoing_event' | translate }}</span>
          </mat-checkbox>
          @if (!selectedOngoing()) {
            <mat-form-field class="half-width">
              <mat-label>{{ 'event.event_date_type' | translate }}</mat-label>
              <mat-select [formField]="eventForm.datesType"
                          placeholder="{{'event.event_date_type_description' | translate}}">
                <mat-option [value]="'oneDay'">
                  {{ 'event.one_day_type' | translate }}
                </mat-option>
                <mat-option [value]="'longEvent'">
                  {{ 'event.long_event_type' | translate }}
                </mat-option>
                <mat-option [value]="'fewDays'">
                  <span [matTooltip]="'event.few_days_tooltip' | translate"
                        [matTooltipClass]="'few-days-tooltip'">{{ 'event.few_days_type' | translate }}</span>
                </mat-option>
              </mat-select>
              @if (eventForm.datesType().invalid() && eventForm.datesType().touched()) {
                <mat-error>
                  @for (error of eventForm.datesType().errors(); track error) {
                    {{ error.message | translate }}
                  }
                </mat-error>
              }
            </mat-form-field>
            @if (eventForm.datesType().value() === 'oneDay' || eventForm.datesType().value() === 'fewDays') {
              <div class="date-list">
                @for (date of eventModel().dates; track $index) {
                  <div class="date">
                    <mat-form-field class="date-field">
                      <mat-label>{{ 'event.event_date' | translate }}</mat-label>
                      <input matInput [matDatepicker]="datepicker" id="{{$index}}_date"
                             [formField]="eventForm.dates[$index].date" [min]="minDate">
                      <mat-datepicker #datepicker/>
                      <mat-datepicker-toggle [for]="datepicker" matSuffix/>
                    </mat-form-field>
                    <mat-form-field class="time-field">
                      <mat-label>{{ 'event.event_start_time' | translate }}</mat-label>
                      <input matInput id="{{$index}}_start_time"
                             [formField]="eventForm.dates[$index].startTime"
                             [matTimepicker]="startTimePicker">
                      <mat-timepicker #startTimePicker/>
                      <mat-timepicker-toggle [for]="startTimePicker" matSuffix/>
                    </mat-form-field>
                    <mat-form-field class="time-field">
                      <mat-label>{{ 'event.event_end' | translate }}</mat-label>
                      <input matInput id="{{$index}}_end_time"
                             [formField]="eventForm.dates[$index].endTime"
                             [matTimepicker]="endTimePicker">
                      <mat-timepicker #endTimePicker/>
                      <mat-timepicker-toggle [for]="endTimePicker" matSuffix/>
                    </mat-form-field>
                    @if ((eventForm.datesType().value() === 'fewDays' || eventForm.datesType().value() === 'oneDay') && eventForm.dates().value().length > 1) {
                      <button [disabled]="disableAll()" mat-icon-button (click)="removeDate($index)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                }
                @if (eventForm.datesType().value() === 'fewDays') {
                  <button [disabled]="disableAll()" mat-raised-button class="mat-accent add-button"
                          (click)="addDate()">{{ 'event.add_date' | translate }}
                  </button>
                }
              </div>
            } @else if (eventForm.datesType().value() === 'longEvent') {
              <div class="date-list">
                <div class="date">
                  <mat-form-field class="date-field">
                    <mat-label>{{ 'event.event_date' | translate }}</mat-label>
                    <mat-date-range-input [rangePicker]="picker" [min]="minDate">
                      <input matStartDate [formField]="eventForm.dates[0].date">
                      <input matEndDate [formField]="eventForm.dates[1].date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                  <mat-form-field class="time-field">
                    <mat-label>{{ 'event.event_start_time' | translate }}</mat-label>
                    <input matInput
                           [formField]="eventForm.dates[0].startTime"
                           [matTimepicker]="startTimePicker">
                    <mat-timepicker #startTimePicker/>
                    <mat-timepicker-toggle [for]="startTimePicker" matSuffix/>
                  </mat-form-field>
                  <mat-form-field class="time-field">
                    <mat-label>{{ 'event.event_end' | translate }}</mat-label>
                    <input matInput
                           [formField]="eventForm.dates[0].endTime"
                           [matTimepicker]="endTimePicker">
                    <mat-timepicker #endTimePicker/>
                    <mat-timepicker-toggle [for]="endTimePicker" matSuffix/>
                  </mat-form-field>
                </div>
              </div>
            }
          }
        </mat-card-content>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.visibility_date' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field class="half-width">
            <mat-label>{{ 'event.date_visible_from' | translate }}</mat-label>
            <input matInput [matDatepicker]="dateVisibleFrom"
                   [formField]="eventForm.dateVisibleFrom" [min]="minDate">
            @if (eventForm.dateVisibleFrom().value()) {
              <mat-icon (click)="cleanDateField('dateVisibleFrom')" class="clean-icon">clear</mat-icon>
            }
            <mat-datepicker #dateVisibleFrom/>
            <mat-datepicker-toggle [for]="dateVisibleFrom" matSuffix/>
          </mat-form-field>
          <mat-form-field class="half-width">
            <mat-label>{{ 'event.date_visible_to' | translate }}</mat-label>
            <input matInput [matDatepicker]="dateVisibleTo"
                   [formField]="eventForm.dateVisibleTo" [min]="minDate">
            @if (eventForm.dateVisibleTo().value()) {
              <mat-icon (click)="cleanDateField('dateVisibleTo')" class="clean-icon">clear</mat-icon>
            }
            <mat-datepicker #dateVisibleTo/>
            <mat-datepicker-toggle [for]="dateVisibleTo" matSuffix/>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.location_description' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field class="full-width">
            <mat-label>{{ 'event.location_detail_description' | translate }}</mat-label>
            <textarea cdkTextareaAutosize
                      cdkAutosizeMinRows="2"
                      cdkAutosizeMaxRows="5"
                      [formField]="eventForm.locationDetail" matInput></textarea>
            @if (eventForm.locationDetail().invalid() && eventForm.locationDetail().touched()) {
              <mat-error>
                @for (error of eventForm.locationDetail().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>
          <mat-checkbox [formField]="eventForm.enableMap" class="full-width">
            {{ 'event.location_on_map' | translate }}
          </mat-checkbox>
          @if (selectedEnableMap()) {
            <mat-checkbox [formField]="eventForm.hideLocation" class="full-width">
              {{ 'event.location_secret' | translate }}
            </mat-checkbox>
            <map-component [initialLocation]="eventModel().location"
                           (locationUpdated)="updateLocation($event)"></map-component>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </mat-expansion-panel>
  <!--  SKILL BLOCK -->
  <mat-expansion-panel expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (competencies().length) {
          {{ 'event.skills_credits_awards' | translate }}
        } @else {
          {{ 'event.credits_awards' | translate }}
        }
        <mat-icon>info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      @if (competencies().length) {
        <mat-card class="card-container">
          <mat-card-header>
            <mat-card-title>{{ 'event.record_skills' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-checkbox [formField]="eventForm.enableSkills" class="full-width">
              {{ 'event.activates_skill_selection' | translate }}
            </mat-checkbox>
            @if (selectedEnableSkills()) {
              <mat-form-field class="full-width">
                <mat-label>{{ 'event.skill_selection' | translate }}</mat-label>
                <mat-select [formField]="eventForm.skills" multiple
                            placeholder="{{'event.skill_selection_description' | translate}}">
                  @for (comp of competencies(); track comp.id) {
                    <mat-optgroup [label]="comp.title">
                      @for (skill of comp.skills; track skill.id) {
                        <mat-option [value]="skill.id">
                          {{ skill.title }}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
                @if (eventForm.skills().invalid() && eventForm.skills().touched()) {
                  <mat-error>
                    @for (error of eventForm.skills().errors(); track error) {
                      {{ error.message | translate }}
                    }
                  </mat-error>
                }
              </mat-form-field>
            }
          </mat-card-content>
        </mat-card>
      }

      <mat-form-field class="full-width">
        <mat-label>{{ 'event.number_of_credits' | translate }}</mat-label>
        <input matInput [formField]="eventForm.credits" type="number">
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>{{ 'event.awards_is_given' | translate }}</mat-label>
        <mat-select [formField]="eventForm.eventLevel" multiple
                    placeholder="{{'event.awards_is_given_description' | translate}}">
          <mat-select-trigger>
            {{ getSelectedEventLevelsDisplay() }}
          </mat-select-trigger>
          @for (el of eventLevels(); track el.id) {
            <mat-option [value]="el.id">
              <div class="level-badge">
                @if (el.badge) {
                  <img [ngSrc]="getImage(el.badge)" width="30" height="30" alt="badge">
                } @else {
                  <mat-icon>workspace_premium</mat-icon>
                }
                {{ el.level }} {{el.status}}
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>{{ 'event.awards_is_prerequisite' | translate }}</mat-label>
        <mat-select [formField]="eventForm.needEventLevel" multiple
                    placeholder="{{'event.awards_is_prerequisite_description' | translate}}">
          <mat-select-trigger>
            {{ getSelectedNeededLevelsDisplay() }}
          </mat-select-trigger>
          @for (el of eventLevels(); track el.id) {
            <mat-option [value]="el.id">
              <div class="level-badge">
                @if (el.badge) {
                  <img [ngSrc]="getImage(el.badge)" width="30" height="30" alt="badge">
                } @else {
                  <mat-icon>workspace_premium</mat-icon>
                }
                {{ el.level }} {{ el.status }}
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-expansion-panel>
  <!--  PARTICIPANT BLOCK -->
  <mat-expansion-panel expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.participation_registration' | translate }}
        <mat-icon [style.color]="!isParticipantValid() ? 'red' : ''">info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      <mat-checkbox [formField]="eventForm.reservationPossible" class="third-width">
        {{ 'event.with_registration' | translate }}
      </mat-checkbox>
      <mat-checkbox [formField]="eventForm.guestEvent" class="third-width">
        {{ 'event.guestEvent' | translate }}
      </mat-checkbox>
      <mat-checkbox [formField]="eventForm.allowGroupRegistration" class="third-width">
        {{ 'event.group_registration' | translate }}
      </mat-checkbox>
      <div class="full-width additional-form">
        <mat-checkbox [formField]="eventForm.additionalForm">
          {{ 'event.additionalForm' | translate }}
        </mat-checkbox>
        <button mat-raised-button class="mat-accent" [disabled]="!eventForm.additionalForm().value()"
                (click)="editGuestSetting()">{{ 'event.guestSettings' | translate }}
        </button>
      </div>
      <mat-checkbox [formField]="eventForm.registrationOnRequest" class="full-width">
        {{ 'event.registration_on_request' | translate }}
      </mat-checkbox>
      <mat-checkbox [formField]="eventForm.hideWaitlist" class="full-width">
        {{ 'event.hideWaitlist' | translate }}
      </mat-checkbox>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.participants' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-checkbox [formField]="eventForm.releaseEvent" class="full-width">
            {{ 'event.release_event' | translate }}
          </mat-checkbox>
          @if (selectedReleaseEvent()) {
            <mat-form-field class="half-width">
              <mat-label>{{ 'event.release_count' | translate }}</mat-label>
              <input matInput [formField]="eventForm.reserveCount" type="number">
            </mat-form-field>
            <mat-form-field class="half-width">
              <mat-label>{{ 'event.personal_count' | translate }}</mat-label>
              <input matInput [formField]="eventForm.reserveOwn" type="number">
            </mat-form-field>
            <mat-checkbox [formField]="eventForm.enrolment" class="full-width">
              {{ 'event.reservation_possibleSub' | translate }}
            </mat-checkbox>
            <mat-form-field class="half-width">
              <mat-label>{{ 'event.endOfReservation' | translate }}</mat-label>
              <input matInput [matDatepicker]="endOfReservation"
                     [formField]="eventForm.endOfReservation" [min]="minDate">
              @if (eventForm.endOfReservation().value()) {
                <mat-icon (click)="cleanDateField('endOfReservation')" class="clean-icon">clear</mat-icon>
              }
              <mat-datepicker #endOfReservation/>
              <mat-datepicker-toggle [for]="endOfReservation" matSuffix/>
            </mat-form-field>
            <hr class="full-width">
            @if (selectedGuestAndReleaseEvent()) {
              <mat-label class="full-width standalone-label">
                {{ 'event.placesFroGuestsInfo' | translate }}
              </mat-label>
              <mat-checkbox [formField]="eventForm.useOrgPlaces" class="full-width">
                {{ 'event.useOrgPlaces' | translate }}
              </mat-checkbox>
              <mat-form-field class="half-width">
                <mat-label>{{ 'event.placesForGuests' | translate }}</mat-label>
                <input matInput [formField]="eventForm.placesForGuests" type="number"
                       [readonly]="selectedUseOrgPlaces()">
              </mat-form-field>
              <hr class="full-width">
            }

          }
          <mat-form-field class="half-width">
            <mat-label>{{ 'event.min_participants' | translate }}</mat-label>
            <input matInput [formField]="eventForm.minParticipants" type="number">
          </mat-form-field>
          <mat-form-field class="half-width">
            <mat-label>{{ 'event.max_participants' | translate }}</mat-label>
            <input matInput [formField]="eventForm.maxParticipants" type="number">
            @if (eventForm.maxParticipants().invalid() && eventForm.maxParticipants().touched()) {
              <mat-error>
                @for (error of eventForm.maxParticipants().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <mat-form-field class="quarter-width">
        <mat-label>{{ 'event.registrationStart' | translate }}</mat-label>
        <input matInput [matDatepicker]="registrationStart"
               [formField]="eventForm.registrationStart" [min]="minDate">
        @if (eventForm.registrationStart().value()) {
          <mat-icon (click)="cleanDateField('registrationStart')" class="clean-icon">clear</mat-icon>
        }
        <mat-datepicker #registrationStart/>
        <mat-datepicker-toggle [for]="registrationStart" matSuffix/>
      </mat-form-field>
      <mat-form-field class="quarter-width">
        <mat-label>{{ 'event.registrationTimeStart' | translate }}</mat-label>
        <input matInput
               [formField]="eventForm.registrationStart"
               [matTimepicker]="registrationStartTimePicker">
        <mat-timepicker #registrationStartTimePicker/>
        <mat-timepicker-toggle [for]="registrationStartTimePicker" matSuffix/>
      </mat-form-field>

      <mat-form-field class="quarter-width">
        <mat-label>{{ 'event.registrationEnd' | translate }}</mat-label>
        <input matInput [matDatepicker]="registrationEnd"
               [formField]="eventForm.registrationEnd" [min]="minDate">
        @if (eventForm.registrationEnd().value()) {
          <mat-icon (click)="cleanDateField('registrationEnd')" class="clean-icon">clear</mat-icon>
        }
        <mat-datepicker #registrationEnd/>
        <mat-datepicker-toggle [for]="registrationEnd" matSuffix/>
      </mat-form-field>
      <mat-form-field class="quarter-width">
        <mat-label>{{ 'event.registrationTimeEnd' | translate }}</mat-label>
        <input matInput
               [formField]="eventForm.registrationEnd"
               [matTimepicker]="registrationTimeEndPicker">
        <mat-timepicker #registrationTimeEndPicker/>
        <mat-timepicker-toggle [for]="registrationTimeEndPicker" matSuffix/>
      </mat-form-field>
    </div>
  </mat-expansion-panel>
<!--  SUB EVENTS BLOCK -->
  <mat-expansion-panel expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.sub_events_block' | translate }}
        <mat-icon [style.color]="!isSubEventPictureValid() ? 'red' : ''">info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      <span [matTooltip]="('event.sub_events_disabled_msg' | translate)"
            [matTooltipDisabled]="isSubEventsTooltipDisabled()">
        <mat-checkbox [formField]="eventForm.subEvents" class="full-width">
        {{ 'event.activate_sub_events' | translate }}
      </mat-checkbox>
      </span>

      @if (selectedSubEvents()) {
        <mat-form-field class="full-width">
          <mat-label>{{ 'event.min_sub_events_count' | translate }}</mat-label>
          <input matInput [formField]="eventForm.minSubEventsCount" type="number">
          @if (eventForm.minSubEventsCount().invalid() && eventForm.minSubEventsCount().touched()) {
            <mat-error>
              @for (error of eventForm.minSubEventsCount().errors(); track error) {
                {{ error.message | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
        <mat-checkbox [formField]="eventForm.allowSameTimeSubEvent" class="full-width">
          {{ 'event.allowSameTimeSubEvent' | translate }}
        </mat-checkbox>
        @for (subevent of eventModel().subEventsData; track $index) {
          <mat-card class="card-container">
            <mat-card-header>
              @if (eventModel().subEventsData[$index].title) {
                <mat-card-title>{{ eventModel().subEventsData[$index].title}}</mat-card-title>
              } @else {
                <mat-card-title>{{ 'event.sub_event' | translate }} {{ $index + 1 }}</mat-card-title>
              }
              <div class="remove-sub-event" [matTooltip]="('event.remove_sub_event' | translate)"
                   (click)="removeSubEvent($index)">
                <mat-icon>remove</mat-icon>
              </div>
            </mat-card-header>
            <mat-card-content>
              <mat-form-field class="full-width">
                <mat-label>{{ 'event.sub_event_title' | translate }}</mat-label>
                <input matInput [formField]="eventForm.subEventsData[$index].title">
                @if (eventForm.subEventsData[$index].title().invalid() && eventForm.subEventsData[$index].title().touched()) {
                  <mat-error>
                    @for (error of eventForm.subEventsData[$index].title().errors(); track error) {
                      {{ error.message | translate }}
                    }
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>{{ 'event.short_description' | translate }}</mat-label>
                <textarea cdkTextareaAutosize
                          cdkAutosizeMinRows="2"
                          cdkAutosizeMaxRows="5"
                          [formField]="eventForm.subEventsData[$index].description" matInput></textarea>
              </mat-form-field>
              @if (!(eventForm.datesType().value() === 'oneDay' && eventForm.dates().value().length === 1)) {
                <mat-form-field class="third-width">
                  <mat-label>{{ 'event.event_start' | translate }}</mat-label>
                  <input matInput [matDatepicker]="subeventStart"
                         [formField]="eventForm.subEventsData[$index].date"
                         [min]="eventForm.datesType().value() === 'longEvent' ? subEventMinDate() : minDate"
                         [max]="eventForm.datesType().value() === 'longEvent' ? subEventMaxDate() : null">
                  <mat-datepicker #subeventStart/>
                  <mat-datepicker-toggle [for]="subeventStart" matSuffix/>
                </mat-form-field>
              }
              <mat-form-field class="third-width">
                <mat-label>{{ 'event.event_start_time' | translate }}</mat-label>
                <input matInput
                       [formField]="eventForm.subEventsData[$index].fromTime"
                       [matTimepicker]="subeventStartTime">
                <mat-timepicker #subeventStartTime/>
                <mat-timepicker-toggle [for]="subeventStartTime" matSuffix/>
              </mat-form-field>
              <mat-form-field class="third-width">
                <mat-label>{{ 'event.event_end' | translate }}</mat-label>
                <input matInput
                       [formField]="eventForm.subEventsData[$index].toTime"
                       [matTimepicker]="subeventEndTime">
                <mat-timepicker #subeventEndTime/>
                <mat-timepicker-toggle [for]="subeventEndTime" matSuffix/>
              </mat-form-field>
              <mat-form-field class="third-width">
                <mat-label>{{ 'event.min_participants' | translate }}</mat-label>
                <input matInput [formField]="eventForm.subEventsData[$index].minParticipants" type="number">
              </mat-form-field>
              <mat-form-field class="third-width">
                <mat-label>{{ 'event.max_participants' | translate }}</mat-label>
                <input matInput [formField]="eventForm.subEventsData[$index].maxParticipants" type="number">
              </mat-form-field>
              <mat-form-field class="third-width">
                <mat-label>{{ 'event.visibility' | translate }}</mat-label>
                <mat-select [formField]="eventForm.subEventsData[$index].visibility">
                  <mat-option [value]="'public'">
                    {{ 'event.public' | translate }}
                  </mat-option>
                  <mat-option [value]="'internal'">
                    {{ 'event.sub_event_internal' | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              @if (subEventCompetencies().length) {
                @if (selectedEnableSkills()) {
                  <mat-form-field class="full-width">
                    <mat-label>{{ 'event.skill_selection' | translate }}</mat-label>
                    <mat-select [formField]="eventForm.subEventsData[$index].skills" multiple
                                placeholder="{{'event.skill_selection_description' | translate}}">
                      @for (comp of subEventCompetencies(); track comp.id) {
                        <mat-optgroup [label]="comp.title">
                          @for (skill of comp.skills; track skill.id) {
                            <mat-option [value]="skill.id">
                              {{ skill.title }}
                            </mat-option>
                          }
                        </mat-optgroup>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              }
              <cropper-component class="full-width" [avatar]="eventModel().subEventsData[$index].picture"
                       [page]="'event'" [defaultRatio]="true" (sendImg)="getImg($event, $index)"
                       (cropperOpened)="openCropper($event)"></cropper-component>
            </mat-card-content>
          </mat-card>
        }
        <button mat-raised-button class="mat-accent add-button"
                (click)="addSubEvent()">{{ 'event.add_sub_events' | translate }}
        </button>
      }
    </div>
  </mat-expansion-panel>
  <!--  ADDITIONAL INFORMATION BLOCK -->
  <mat-expansion-panel expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'event.additional_information' | translate }}
        <mat-icon>info</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container">
      <mat-checkbox [formField]="eventForm.mileStone" class="full-width">
        <span [matTooltip]="('event.milestone_desc' | translate)">{{ 'event.milestone' | translate }}</span>
      </mat-checkbox>
      <mat-form-field class="full-width">
        <mat-label>{{ 'event.weblinks' | translate }}</mat-label>
        <mat-chip-grid #weblinksChipGrid>
          @for (weblink of eventModel().weblinks; track $index) {
            <mat-chip-row (removed)="removeWeblink(weblink)">
              {{ weblink }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          placeholder="{{ 'event.add_link_placeholder' | translate }}"
          [matChipInputFor]="weblinksChipGrid"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addWeblink($event)"
        />
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label>{{ 'event.costs' | translate }}</mat-label>
        <input [formField]="eventForm.cost" type="number" matInput>
        <span matTextPrefix>CHF</span>
        <span matTextSuffix>.-</span>
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label>{{ 'event.costFriend' | translate }}</mat-label>
        <input [formField]="eventForm.costFriend" type="number" matInput>
        <span matTextPrefix>CHF</span>
        <span matTextSuffix>.-</span>
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label>{{ 'event.gender' | translate }}</mat-label>
        <mat-select [formField]="eventForm.gender">
          <mat-option [value]="'all'">
            {{ 'event.gender_all' | translate }}
          </mat-option>
          <mat-option [value]="'male'">
            {{ 'event.gender_male' | translate }}
          </mat-option>
          <mat-option [value]="'female'">
            {{ 'event.gender_female' | translate }}
          </mat-option>
          <mat-option [value]="'diverse'">
            {{ 'event.gender_diverse' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.record_support_requirements' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field class="full-width">
            <mat-label>{{ 'event.record_support_requirements_description' | translate }}</mat-label>
            <textarea cdkTextareaAutosize
                      cdkAutosizeMinRows="2"
                      cdkAutosizeMaxRows="5"
                      [formField]="eventForm.pickUp" matInput></textarea>
          </mat-form-field>
          <document-component [type]="'newEvent'" [uniqueId]="'supportRequirements'"
                              [uploadedFilesInput]="getSupportRequirements()"
                              (fileDeleted)="handleFileDeleted($event)"
                              (newFileDeleted)="handleNewFileDeleted($event)"
                              (filesToUpload)="addDocuments($event, 'supportRequirements')"
          (filesAccess)="setFilesAccess($event)"></document-component>
        </mat-card-content>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.display_conditions_of_participation' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field class="full-width">
            <mat-label>{{ 'event.display_conditions_of_participation' | translate }}</mat-label>
            <textarea cdkTextareaAutosize
                      cdkAutosizeMinRows="2"
                      cdkAutosizeMaxRows="5"
                      [formField]="eventForm.conditionsOfParticipation" matInput></textarea>
          </mat-form-field>
          <document-component [type]="'newEvent'" [uniqueId]="'conditionsOfParticipation'"
                              [uploadedFilesInput]="getConditionsOfParticipation()"
                              (filesAccess)="setFilesAccess($event)"
                              (fileDeleted)="handleFileDeleted($event)"
                              (newFileDeleted)="handleNewFileDeleted($event)"
                              (filesToUpload)="addDocuments($event, 'conditionsOfParticipation')"></document-component>
        </mat-card-content>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.upload_documents' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <document-component [type]="'newEvent'" [uniqueId]="'documents'"
                              [uploadedFilesInput]="getEventDocuments()"
                              (filesAccess)="setFilesAccess($event)"
                              (fileDeleted)="handleFileDeleted($event)"
                              (newFileDeleted)="handleNewFileDeleted($event)"
                              (filesToUpload)="addDocuments($event)"></document-component>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-expansion-panel>
  <!--  TIME AND BUDGET BLOCK -->
  @if (showTimeAndBudget()) {
    <mat-expansion-panel expanded="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'event.time_and_budget' | translate }}
          <mat-icon>info</mat-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="form-container">
        <mat-card class="card-container">
          <mat-card-header>
            <mat-card-title>{{ 'budget.budget' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-form-field class="half-width">
              <mat-label>{{ 'budget.material' | translate }}</mat-label>
              <input [formField]="eventForm.material" type="number" matInput>
              <span matTextPrefix>CHF</span>
              <span matTextSuffix>.-</span>
            </mat-form-field>
            <mat-form-field class="half-width">
              <mat-label>{{ 'budget.meals' | translate }}</mat-label>
              <input [formField]="eventForm.meals" type="number" matInput>
              <span matTextPrefix>CHF</span>
              <span matTextSuffix>.-</span>
            </mat-form-field>
            <mat-form-field class="half-width">
              <mat-label>{{ 'budget.transport' | translate }}</mat-label>
              <input [formField]="eventForm.transport" type="number" matInput>
              <span matTextPrefix>CHF</span>
              <span matTextSuffix>.-</span>
            </mat-form-field>
            <mat-form-field class="half-width">
              <mat-label>{{ 'budget.rents' | translate }}</mat-label>
              <input [formField]="eventForm.rents" type="number" matInput>
              <span matTextPrefix>CHF</span>
              <span matTextSuffix>.-</span>
            </mat-form-field>
            <mat-form-field class="half-width">
              <mat-label>{{ 'budget.miscellaneous' | translate }}</mat-label>
              <input [formField]="eventForm.miscellaneous" type="number" matInput>
              <span matTextPrefix>CHF</span>
              <span matTextSuffix>.-</span>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-card class="card-container">
          <mat-card-header>
            <mat-card-title>{{ 'budget.time' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-label class="full-width standalone-label">{{ 'budget.preparation' | translate }}</mat-label>
            <mat-form-field class="quarter-width">
              <input [formField]="eventForm.preparationMin" type="number" matInput>
              <div matTextSuffix class="time-icon-suffix">
                <mat-icon class="time-icon">schedule</mat-icon>
              </div>
            </mat-form-field>
            <mat-form-field class="quarter-width">
              <input [formField]="eventForm.preparationMax" type="number" matInput>
              <div matTextSuffix class="time-icon-suffix">
                <mat-icon class="time-icon">schedule</mat-icon>
              </div>
            </mat-form-field>

            <mat-label class="full-width standalone-label">{{ 'budget.execution' | translate }}</mat-label>
            <mat-form-field class="quarter-width">
              <input [formField]="eventForm.executionMin" type="number" matInput>
              <div matTextSuffix class="time-icon-suffix">
                <mat-icon class="time-icon">schedule</mat-icon>
              </div>
            </mat-form-field>
            <mat-form-field class="quarter-width">
              <input [formField]="eventForm.executionMax" type="number" matInput>
              <div matTextSuffix class="time-icon-suffix">
                <mat-icon class="time-icon">schedule</mat-icon>
              </div>
            </mat-form-field>

            <mat-label class="full-width standalone-label">{{ 'budget.follow-up' | translate }}</mat-label>
            <mat-form-field class="quarter-width">
              <input [formField]="eventForm.followUpMin" type="number" matInput>
              <div matTextSuffix class="time-icon-suffix">
                <mat-icon class="time-icon">schedule</mat-icon>
              </div>
            </mat-form-field>
            <mat-form-field class="quarter-width">
              <input [formField]="eventForm.followUpMax" type="number" matInput>
              <div matTextSuffix class="time-icon-suffix">
                <mat-icon class="time-icon">schedule</mat-icon>
              </div>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-expansion-panel>
  }
</mat-accordion>

